__turbopack_context__.v({
  "DM_12_24_Link_B": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_12_24_Link_B",
  "DM_14_24_Link_B": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_14_24_Link_B",
  "DM_20_24_Bold": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_20_24_Bold",
  "DM_Body_Reg_16": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Body_Reg_16",
  "DM_Bold_14_16": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Bold_14_16",
  "DM_Bold_14_24_UC": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Bold_14_24_UC",
  "DM_Bold_16_24": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Bold_16_24",
  "DM_Bold_20_24": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Bold_20_24",
  "DM_Bold_40_56": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Bold_40_56",
  "DM_Btn_16_16_Med": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Btn_16_16_Med",
  "DM_Med_10_12": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Med_10_12",
  "DM_Med_12_12_Chip": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Med_12_12_Chip",
  "DM_Med_12_16": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Med_12_16",
  "DM_Med_14_16": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Med_14_16",
  "DM_Med_14_20": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Med_14_20",
  "DM_Med_14_24": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Med_14_24",
  "DM_Med_16_16": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Med_16_16",
  "DM_Med_16_24": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Med_16_24",
  "DM_Med_18_24": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Med_18_24",
  "DM_Med_20_24": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Med_20_24",
  "DM_Med_24_24": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Med_24_24",
  "DM_Med_32_32": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Med_32_32",
  "DM_Med_32_48": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Med_32_48",
  "DM_Med_8_8": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Med_8_8",
  "DM_Reg_10_10": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Reg_10_10",
  "DM_Reg_12_12_Chip": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Reg_12_12_Chip",
  "DM_Reg_12_16": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Reg_12_16",
  "DM_Reg_14_16": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Reg_14_16",
  "DM_Reg_14_24": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Reg_14_24",
  "DM_Reg_14_32_Table": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Reg_14_32_Table",
  "DM_Reg_16_16_Chip": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Reg_16_16_Chip",
  "DM_Reg_16_20": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Reg_16_20",
  "DM_Reg_16_24": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Reg_16_24",
  "DM_Reg_16_24_Italic": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Reg_16_24_Italic",
  "DM_Reg_18_28": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Reg_18_28",
  "DM_Reg_32_32": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Reg_32_32",
  "DM_Reg_40_56": "ProfileConfigureTotp-module-scss-module__ruSgdq__DM_Reg_40_56",
  "buttonLink": "ProfileConfigureTotp-module-scss-module__ruSgdq__buttonLink",
  "center": "ProfileConfigureTotp-module-scss-module__ruSgdq__center",
  "container": "ProfileConfigureTotp-module-scss-module__ruSgdq__container",
});
